"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const Field_1 = __importDefault(require("./Field"));
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
class Provider {
    constructor(config) {
        this.currentPage = 1;
        this.nextPage = 2;
        this.fieldsPerPage = 20;
        this.fieldsPages = [];
        this.totalPages = 1;
        this.loading = false;
        this.id = config.id;
        this.name = config.name;
        this.logo = config.logo;
        this.linked = config.linked;
        this.disabled = config.disabled;
        this.fields = [];
        this.currentPage = 1;
        this.nextPage = 2;
        this.fieldsPerPage = 10;
        this.fieldsPages = [];
        this.totalPages = 1;
        this.totalFields = 1;
        this.loading = false;
        this.fieldsP = [];
        this.pageSize = 10;
    }
    reset() {
        this.fields = [];
        this.currentPage = 1;
        this.nextPage = 2;
        this.fieldsPerPage = 10;
        this.fieldsPages = [];
        this.totalPages = 1;
        this.totalFields = 1;
        this.loading = false;
        this.fieldsP = [];
        this.pageSize = 10;
    }
    async auth() {
        try {
            const call = await axios_1.default.post('/integrations/leaf/auth', { provider: this.name, origin: window.location.pathname });
            this.openAuthView(call.data.url);
        }
        catch (error) {
            console.error(error);
        }
    }
    openAuthView(path) {
        window.open(path, '_blank');
    }
    async getFields(page) {
        try {
            this.loading = true;
            if (page > this.totalPages) {
                console.warn('This page does not exist!');
            }
            else {
                this.fieldsP = [];
                const response = await axios_1.default.get(`/integrations/leaf/fields/list?provider=${this.name}&page=${page}&size=${this.pageSize}`);
                this.currentPage = page;
                response.data.fields.forEach((field) => {
                    const fieldModel = new Field_1.default({
                        id: field.leafFieldId,
                        gfId: field.gfId,
                        fieldName: field.fieldName,
                        farmId: field.leafFarmId,
                        farmName: field.leafFarmName,
                        size: field.extension,
                        sizeUnit: field.extension_units,
                        managementPractice: null,
                        crop: new Crop_1.default({
                            id: -1,
                            name: '-',
                            color: '#eebb54',
                            icon: '-'
                        }),
                        geodata: field.geometry,
                        origin: '',
                        metadata: [],
                        projection: '',
                        quoteId: -1,
                        ebecrop: false,
                        provider: 'setup-leaf-' + this.name,
                        providerFieldId: field.leafFieldId
                    });
                    this.fields.push(fieldModel);
                    this.fieldsP.push(fieldModel);
                });
                this.fieldsPages.push({ page: page, farms: this.fieldsP });
                this.fieldsP.sort((a, b) => a.farmName.localeCompare(b.farmName));
                this.totalPages = Math.ceil(response.data.pagination.total / this.pageSize);
                this.totalFields = response.data.pagination.total;
                this.loading = false;
            }
            /*  if (this.fieldsNextPage !== null && !this.visitedPages.has(this.fieldsNextPage)) {
                 const call = await axios.get(`/integrations/leaf/fields/list?provider=${this.name}&page=${this.fieldsNextPage}&size=10`);
 
                 this.visitedPages.add(this.fieldsNextPage);
                 this.fieldsCurrentPage = this.fieldsNextPage;
                 this.fieldsNextPage = call.data.pagination.next_page;
                 this.totalFields = call.data.pagination.total
                 const last = [];
 
                 call.data.fields.forEach((field, index) => {
                     const fieldModal = new Field({
                         id: index,
                         fieldName: field.fieldName,
                         farmId: field.leafFarmId,
                         farmName: field.leafFarmName,
                         size: field.extension,
                         sizeUnit: field.extension_units,
                         managementPractice: null,
                         crop: null,
                         geodata: field.geometry,
                         origin: '',
                         metadata: [],
                         projection: '',
                         quoteId: -1,
                         ebecrop: false
                     });
                     this.fields.push(fieldModal);
                     last.push(fieldModal);
                 });
 
                 this.lastFields = last;
                 this.fields.sort((a, b) => a.farmName.localeCompare(b.farmName));
             } */
        }
        catch (error) {
            console.error(error);
        }
    }
    async getAllFields() {
        try {
            this.loading = true;
            let page = this.currentPage + 1;
            while (page < this.totalPages) {
                const response = await axios_1.default.get(`/integrations/leaf/fields/list?provider=${this.name}&page=${page}&size=${this.pageSize}`);
                /*  if (page === 0) {
                     this.totalPages = Math.ceil(response.data.pagination.total / this.pageSize);
                     this.totalFields = response.data.pagination.total;
                 } */
                const fieldsP = response.data.fields.map((field) => new Field_1.default({
                    id: field.leafFieldId,
                    fieldName: field.fieldName,
                    farmId: field.leafFarmId,
                    farmName: field.leafFarmName,
                    size: field.extension,
                    sizeUnit: field.extension_units,
                    managementPractice: null,
                    crop: new Crop_1.default({
                        id: -1,
                        name: '-',
                        color: '#eebb54',
                        icon: '-'
                    }),
                    geodata: field.geometry,
                    origin: '',
                    metadata: [],
                    projection: '',
                    quoteId: -1,
                    ebecrop: false,
                    provider: 'setup-leaf-' + this.name,
                    providerFieldId: field.leafFieldId
                }));
                this.fields.push(...fieldsP);
                this.fieldsPages.push({ page, farms: fieldsP });
                page++;
            }
            this.fields.sort((a, b) => a.farmName.localeCompare(b.farmName));
            this.loading = false;
        }
        catch (error) {
            console.error('Error fetching fields:', error);
            this.loading = false;
        }
    }
    wkbToWktMultiPolygon(wkbHex) {
        // Convierte el WKB hexadecimal a un buffer de bytes
        const wkbBuffer = Buffer.from(wkbHex, 'hex');
        // Decodifica el buffer en coordenadas (implementación personalizada)
        const coordinates = this.decodeWkbToCoordinates(wkbBuffer);
        // Construye el MULTIPOLYGON WKT
        const wktMultiPolygon = `MULTIPOLYGON(((${coordinates.map(ring => ring.map(([x, y]) => `${x} ${y}`).join(', ')).join('), (')})))`;
        return wktMultiPolygon;
    }
    // Decodifica el WKB en coordenadas
    decodeWkbToCoordinates(wkbBuffer) {
        let offset = 0;
        // Lee el tipo de byte para el endianess
        const isLittleEndian = wkbBuffer.readUInt8(offset) === 1;
        offset += 1;
        // Lee el tipo de geometría (0x300 = POLYGON)
        const geometryType = isLittleEndian
            ? wkbBuffer.readUInt32LE(offset)
            : wkbBuffer.readUInt32BE(offset);
        offset += 4;
        if (geometryType !== 3) {
            throw new Error('El WKB no es un POLYGON.');
        }
        // Lee el número de anillos
        const numRings = isLittleEndian
            ? wkbBuffer.readUInt32LE(offset)
            : wkbBuffer.readUInt32BE(offset);
        offset += 4;
        const coordinates = [];
        for (let i = 0; i < numRings; i++) {
            // Lee el número de puntos en el anillo
            const numPoints = isLittleEndian
                ? wkbBuffer.readUInt32LE(offset)
                : wkbBuffer.readUInt32BE(offset);
            offset += 4;
            const ring = [];
            for (let j = 0; j < numPoints; j++) {
                // Lee las coordenadas X y Y
                const x = isLittleEndian
                    ? wkbBuffer.readDoubleLE(offset)
                    : wkbBuffer.readDoubleBE(offset);
                offset += 8;
                const y = isLittleEndian
                    ? wkbBuffer.readDoubleLE(offset)
                    : wkbBuffer.readDoubleBE(offset);
                offset += 8;
                ring.push([x, y]);
            }
            coordinates.push(ring);
        }
        return coordinates;
    }
}
exports.default = Provider;
